import { createApp } from 'vue'
import App from './App.vue';
import '@/assets/css/bootstrap.css'
import '@/assets/css/style.css'
import '@/assets/css/responsive.css'
import '@/assets/css/flaticon_palace-icons.css'
import router from './router';
import i18n from './i18n'
//slider
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
//language
const savedLang = localStorage.getItem("lang") || "en"
i18n.global.locale.value = savedLang
document.documentElement.lang = savedLang
document.documentElement.dir = savedLang === "ar" ? "rtl" : "ltr"
//toast
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
//head for seo
import { createHead } from '@unhead/vue'
const head = createHead()
//pinia
import { createPinia } from 'pinia'
const pinia = createPinia()

const app = createApp(App)
app.use(router)
.use(i18n)
.use(Toast)
.use(head)
.use(pinia)
.mount('#app')
